<template>
  <div class="linkedin-post-attachment">
    <div class="linkedin-post-attachment__header">
      <Icon icon="mdi:linkedin" class="linkedin-post-attachment__header-icon" />
      <span class="linkedin-post-attachment__header-title">LinkedIn post</span>
    </div>
    <div v-if="attachment.author" class="linkedin-post-attachment__author">
      <img
        v-if="attachment.author.profile_picture_url"
        :src="attachment.author.profile_picture_url"
        class="linkedin-post-attachment__avatar"
        alt="Author"
      />
      <div class="linkedin-post-attachment__author-info">
        <span class="linkedin-post-attachment__author-name">{{
          attachment.author.name || "Unknown"
        }}</span>
        <span v-if="attachment.author.headline" class="linkedin-post-attachment__author-headline">
          {{ attachment.author.headline }}
        </span>
      </div>
    </div>
    <div v-if="attachment.text" class="linkedin-post-attachment__text">
      {{ attachment.text }}
    </div>
    <a
      v-if="attachment.share_url || attachment.url"
      :href="attachment.share_url || attachment.url"
      target="_blank"
      class="linkedin-post-attachment__link"
      @click.stop
    >
      <span>View on LinkedIn</span>
    </a>
  </div>
</template>

<script setup lang="ts">
import type { Attachment } from "@/dtos/Unipile.dto";
import { Icon } from "@iconify/vue";

interface Props {
  attachment: Attachment;
}

defineProps<Props>();
</script>

<style scoped>
.linkedin-post-attachment {
  padding: 1rem;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.linkedin-post-attachment__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.linkedin-post-attachment__header-icon {
  font-size: 1.125rem;
  color: #0077b5;
}

.linkedin-post-attachment__header-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
}

.linkedin-post-attachment__author {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.linkedin-post-attachment__avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.linkedin-post-attachment__author-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.linkedin-post-attachment__author-name {
  font-weight: 600;
  font-size: 0.875rem;
  color: #111827;
}

.linkedin-post-attachment__author-headline {
  font-size: 0.75rem;
  color: #6b7280;
}

.linkedin-post-attachment__text {
  margin-bottom: 0.75rem;
  line-height: 1.5;
  font-size: 0.875rem;
  color: #111827;
}

.linkedin-post-attachment__link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #0077b5;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: color 0.2s;
}

.linkedin-post-attachment__link:hover {
  color: #006399;
  text-decoration: underline;
}
</style>
